import React from "react";


function Timing() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/slider-1.jpg)',backgroundSize:'cover',backgroundPosition:'top'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px',padding:'50px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row">
          <div class="col-md-12" style={{backgroundImage:'url(./images/slider-1.jpg)',backgroundSize:'cover',backgroundPosition:'center',height:'100px'}}>
                
            </div>
            <div className="col-md-12" style={{background:'#ffffffd2',padding:'50px',border:'1px solid silver'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">Darshan Timings / ദർശന സമയം</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'50px',paddingTop:'15px'}}>
                    {/* <center>
                          <h3 className="theading" style={{fontSize:'20px',fontWeight:'700',marginTop:'-20px',textAlign:'center'}}>Alpashi Festival from 16-10-2025 to 31-10-2025</h3>
                      </center> */}
                    {/* first */}


                   
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">03:30 AM - നടതുറക്കല്‍</li>
                                <li className="timelist">05:30 AM - മഹാഗണപതിഹോമം</li>
                                <li className="timelist">06:30 AM - ഉഷപൂജ</li>
                                <li className="timelist">09:30 AM - ഉച്ചപൂജ</li> 
                                 <li className="timelist">10:00 AM - നട അടയ്ക്കല്‍</li> 
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                    <li className="timelist">05:00 PM - നടതുറക്കല്‍</li>
                                    <li className="timelist">06:30 PM - ദീപാരാധന</li>
                                    <li className="timelist">07:30 PM - അത്താഴപൂജ, ശ്രീഭൂതബലി</li>
                                    <li className="timelist">08:00 PM - നട അടയ്ക്കല്‍</li>
                                </ul>
                      </div>
                    </div>
                    <p className="timelist">
                        വിശേഷ ദിവസങ്ങളില്‍ പൂജാസമയത്തിന് മാറ്റം   വരുന്നതാണ്. ഉദ്ദിഷ്ടകാര്യ   ഫലസിദ്ധിപൂജ എല്ലാ   ചൊവ്വാഴ്ചയും രാവിലെ 9.30-ന്. എല്ലാ മാസവും ആയില്യം നാളില്‍ ആയില്യപൂജ ഉണ്ടായിരിക്കുന്നതാണ്. ദേവിയുടെ ജന്മനക്ഷത്രമായ മകം നാളില്‍ അഖണ്ഡനാമജപം ഉണ്ടായിരിക്കുന്നതാണ്. എല്ലാ മാസവും മുരുകന് ഷഷ്ടിപൂജ, വിശേഷാല്‍ അഭിഷേകം എന്നിവ ഉണ്ടായിരിക്കും.
                    </p>
                </div>
           </div> 
            
        </div>
        
        
      </div>
    </div>
  );
}

export default Timing;